import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { resendConfirmationEmailThunk } from '@redux/oauth/oauthThunks';
import { getAcceptedInvitationByEmailThunk } from '@redux/person/personThunks';
import { AppDispatch } from '@redux/store';
import { useAlert } from 'components/AlertInfoGlobal/useAlert';
import { Button } from 'components/Button/Button';
import style from './AdminUserPermissions.scss';

interface Props {
  email?: string | null;
}

export const ResendInviteButton: React.FC<Props> = ({ email }) => {
  const dispatch = useDispatch<AppDispatch>();
  const [accepted, setAccepted] = useState<boolean>(true);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const { showAlertInfo } = useAlert();

  useEffect(() => {
    if (!email) return;
    (async () => {
      try {
        const result = await dispatch(getAcceptedInvitationByEmailThunk(email));
        setAccepted(result);
      } catch {
        setAccepted(true);
      }
    })();
  }, [dispatch, email]);

  const handleClick = async () => {
    if (!email || accepted) return;
    await dispatch(resendConfirmationEmailThunk(email));
    showAlertInfo({
      message: 'Invite email sent!'
    });
    setIsSuccess(true);
  };

  return (
    <Button variant="outlined" disabled={accepted || isSuccess} onClick={handleClick} className={style.resendButton} data-testid={`resend-invite-button-${email}`}>
      Resend Invite
    </Button>
  );
};

export default ResendInviteButton;
